import { ValidationErrors } from "@certn/forms/src/CascadiaJsonFormContext";

export class CascadiaFormSubmissionError {
  errors: ValidationErrors;

  constructor(errors: ValidationErrors) {
    this.errors = errors;
  }
}
